import {inject, injectable} from 'inversify';

import type {CourseExpandFieldsCommon} from '../../../../api/course';
import type {Expand} from '../../../../api/types';

import {EnvProviderService} from '../../../system/env/EnvProvider.service';
import {BaseExpandJrpc} from '../../Base/mappers/Base.expand.jrpc';
import {UserExpandJrpc} from '../../User/mappers/User.expand.jrpc';

@injectable()
export class AppEventExpandJrpc extends BaseExpandJrpc {
  constructor(
    @inject(EnvProviderService) env: EnvProviderService,
    @inject(UserExpandJrpc)
    private readonly userExpand: UserExpandJrpc,
  ) {
    super(env);
  }

  getByEnv(key?: BaseExpandJrpc.EnvKey): Expand {
    const base: Expand = {
      event: [
        ['actor_id', null, this.userExpand.getByEnv(key)],
        ['user_id', null, this.userExpand.getByEnv(key)],
        'context_ids',
      ],
    };
    const core: Expand = base;
    const b2b: Expand = base;

    return this.resolve({b2b, core, key});
  }
}

export namespace CourseExpandJrpc {
  export type ExpandedFields = CourseExpandFieldsCommon;
}
